var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import WalletBar from "../../parts/WalletBar";
import { WalletsHelper } from "../../../lib/storage";
import Vue from 'vue';
export default Vue.extend({
    components: { WalletBar },
    data() {
        return {
            updateWalletBar: false,
            activeIndex: 0,
            wallets: [],
        };
    },
    name: "WalletSelect",
    methods: {
        setActiveWallet(wallet) {
            return __awaiter(this, void 0, void 0, function* () {
                yield WalletsHelper.setActive(wallet.id);
                this.activeIndex = yield this.getActiveWalletIndex();
                this.updateWalletBar = true;
            });
        },
        getActiveWalletIndex() {
            return __awaiter(this, void 0, void 0, function* () {
                const wallets = yield WalletsHelper.gets();
                const activeWallet = yield WalletsHelper.getActive();
                if (!activeWallet) {
                    return -1;
                }
                for (let index = 0; index < wallets.length; index++) {
                    if (wallets[index].id === activeWallet.id) {
                        return index;
                    }
                }
                return -1;
            });
        }
    },
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            this.activeIndex = yield this.getActiveWalletIndex();
            this.wallets = yield WalletsHelper.gets();
        });
    },
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/wallet/WalletSelect.vue
// module id = 611
// module chunks = 1